import React, { useEffect, useRef } from "react";
import { ModalUi } from "../../../ui/ModalUi";
import { useDispatch, useSelector } from "react-redux";
import { TipoButtonConstants } from "../../../../types/typesConstants";
import { ButtonUi } from "../../../ui/ButtonUi";
import { FormUi } from "../../../ui/FormUi";
import { Col, Form, Input, Row } from "antd";
import { usuarioStartUpdate } from "../../../../actions/usuario";
const initialValues = {
  password: null,
  confirm: null,
};
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const useResetFormOnCloseModal = ({ form, open }) => {
  const prevOpenRef = useRef();

  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;

  useEffect(() => {
    if (!open && prevOpen) {
      form.resetFields();
    }
  }, [form, prevOpen, open]);
};
export const ChangePasswordModal = ({ openModal, handleCancelModal }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { activeUsuario } = useSelector((state) => state.usuario);
  useResetFormOnCloseModal({ form, open: openModal });
  const handleSubmit = (values) => {
    values = { ...activeUsuario, password: values?.password };
    dispatch(usuarioStartUpdate(values));
    handleCancelModal();
  };
  return (
    <ModalUi
      title={
        <>
          Usuario
          {activeUsuario ? <small> Editar</small> : <small> Nuevo</small>}
        </>
      }
      open={openModal}
      onCancel={handleCancelModal}
      //   width="70%"
      footer={[
        <ButtonUi
          key="back"
          typeUi={TipoButtonConstants.Cancelar}
          onClick={handleCancelModal}
        />,
        <ButtonUi
          typeUi={TipoButtonConstants.Guardar}
          form="FormChangeUsuario"
          key="submit"
          htmlType="submit"
        />,
      ]}
      forceRender
    >
      <FormUi
        form={form}
        name="FormChangeUsuario"
        layout="horizontal"
        autoComplete="off"
        initialValues={initialValues}
        handleSubmit={handleSubmit}
        {...formItemLayout}
      >
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <Form.Item
              name="password"
              label="Password"
              rules={[
                {
                  required: true,
                  message: "¡Ingrese el password!",
                },
              ]}
              hasFeedback
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="confirm"
              label="Confirmar Password"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "¡Por favor confirmar el password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "¡La nueva contraseña que ingresaste no coincide!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
      </FormUi>
    </ModalUi>
  );
};
